import { m } from "framer-motion";
import { CLIP_FOOTER, FRONT_DOOR_STATS } from "@/content/marketing";

const TESTFLIGHT_URL = "https://testflight.apple.com/join/4Ym7X41D";

/**
 * Home — the distribution argument: a clip is a front door, and the card on the
 * right is literally what a reader sees at the bottom of one.
 *
 * Because it says "literally", the card's copy comes from CLIP_FOOTER — the
 * backend's shipped clip CTA — and not from anything written for this page.
 * The styling is ours; the words are the product's.
 */
export default function FrontDoorSection() {
  return (
    <section className="px-6 pb-[76px] md:px-8">
      <m.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.55 }}
        className="mx-auto grid max-w-6xl items-center gap-10 rounded-3xl border border-white/[0.08] bg-[linear-gradient(135deg,rgba(46,115,184,0.16),rgba(168,85,247,0.16))] p-8 md:grid-cols-[1fr_0.9fr] md:p-11"
      >
        <div>
          <h2 className="text-3xl font-extrabold leading-[1.1] tracking-[-0.032em] text-ios md:text-[38px]">
            Every clip you send is a front door.
          </h2>
          <p className="mt-3.5 text-base leading-[1.55] text-[#B9C4D0]">
            Clips open for anyone, on any device, with no install and no account. The people who read
            yours are one tap from making their own.
          </p>

          <dl className="mt-7 flex flex-wrap gap-x-[34px] gap-y-4">
            {FRONT_DOOR_STATS.map((stat) => (
              <div key={stat.label}>
                <dt className="text-3xl font-extrabold text-ios">{stat.value}</dt>
                <dd className="mt-0.5 text-[12.5px] text-ios-secondary">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="rounded-[18px] border border-white/[0.09] bg-black/35 p-[22px]">
          <p className="ios-chip-label text-ios-muted">What readers see at the bottom</p>
          <div className="mt-3.5 rounded-2xl bg-[linear-gradient(135deg,#2E73B8,#A855F7)] p-[22px] text-center">
            <img
              src="/images/logo-m.png"
              alt=""
              width="34"
              height="34"
              className="mx-auto h-[34px] w-[34px] rounded-[9px] object-cover"
            />
            <p className="mt-2 text-[17px] font-bold leading-[1.35] text-white">
              {CLIP_FOOTER.heading}
            </p>
            <p className="mt-1 text-[12.5px] text-white/75">{CLIP_FOOTER.body}</p>
            <a
              href={TESTFLIGHT_URL}
              target="_blank"
              rel="noreferrer"
              className="mt-[13px] inline-block rounded-[18px] bg-white px-[22px] py-[9px] text-[13.5px] font-bold text-[#1A5FA4] transition-opacity hover:opacity-90"
            >
              {CLIP_FOOTER.buttonLabel}
            </a>
          </div>
        </div>
      </m.div>
    </section>
  );
}
